import { HONEYPOT_CHECKBOX, HONEYPOT_FIELDS } from "@/lib/form-security";

/**
 * Off-screen decoy inputs. Hidden from sighted users AND assistive tech
 * (aria-hidden + tabIndex -1 + autoComplete off), so they only ever get
 * filled by form-scraping bots. Pair with `evaluateBotSignals`.
 *
 * Deliberately NOT `display:none` / `hidden` — many bots skip those.
 */
export function HoneypotFields() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute left-[-9999px] top-0 h-0 w-0 overflow-hidden"
    >
      {HONEYPOT_FIELDS.map((name) => (
        <input
          key={name}
          type="text"
          name={name}
          tabIndex={-1}
          autoComplete="off"
          defaultValue=""
        />
      ))}
      <input type="checkbox" name={HONEYPOT_CHECKBOX} tabIndex={-1} defaultChecked={false} />
    </div>
  );
}
